// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__1Gjje","scrollStub":"styles_scrollStub__sN_yg","footer":"styles_footer___m3rq","content":"styles_content__GK2Jf"};